<template>
    <div>
      <div class="col-12 lg:col-12 px-0">
        <Toolbar class="mb-2">
          <template #end>
            <Button
              label="Nuevo"
              icon="pi pi-plus"
              class="p-button-success mr-2"
              @click="agregarModalidad"
            />
          </template>
        </Toolbar>
      </div>
  
      <DataTable
        :value="lstModalidades"
        dataKey="Id_tipo_modalidad"
        ref="dt"
        v-model:filters="filters"
        :globalFilterFields="['Descripcion']"
        :loading="loading"
        :paginator="true"
        :rows="20"
        responsiveLayout="scroll"
      >
        <template #header>
          <div class="table-header">
            <h5>Tipos de modalidades</h5>
            <span>Número de modalidades {{ lstModalidades ? lstModalidades.length : 0 }}</span>
            <span class="p-input-icon-left">
              <i class="pi pi-search" />
              <InputText
                type="text"
                v-model="filters['global'].value"
                placeholder="Buscar..."
              />
            </span>
          </div>
        </template>
        <template #empty> No se encontrarón registros. </template>
        <template #loading> Cargando datos. Espere por favor. </template>
        <Column field="Descripcion" header="SERVCIO" sortable>
          <template #body="{data}"> {{ data.Descripcion }}</template>
        </Column>
        <Column field="Activo" header="ESTATUS" sortable>
          <template #body="slotProps">
            <span class="status-activo" v-show="slotProps.data.Estatus == 'ACTIVO'"> ACTIVO </span>
            <span class="status-inactivo" v-show="slotProps.data.Estatus == 'INACTIVO'"> INACTIVO </span>
          </template>
        </Column>
        <Column :exportable="false">
          <template #body="slotProps">
            <Button
              icon="pi pi-pencil"
              class="p-button-rounded p-button-success"
              @click="edit(slotProps.data)"
            />
            <Button
              style="margin-left: 8px"
              icon="pi pi-times"
              class="p-button-rounded p-button-danger"
              @click="borrar(slotProps.data)"
            />
          </template>
        </Column>
        <template #footer>
          Registros en total {{ lstModalidades ? lstModalidades.length : 0 }}
        </template>
      </DataTable>
  
      <Dialog :style="{ width: '600px' }" :visible="showAgregar" :modal="true" class="p-fluid" :closable="false">
        <template #header>
          <h3>{{ modoEdicion }} modalidad</h3>
        </template>
  
        <div class="p-formgrid grid">
          <div class="p-field col">
            <label for="Modalidad">Modalidad</label>
            <InputText
              autocomplete="off"
              id="Producto"
              v-model.trim="modalidad.Descripcion"
              required="true"
              autofocus
              :class="{ 'p-invalid': submitted && !modalidad.Descripcion }"
            />
            <small class="p-invalid" v-if="submitted && !modalidad.Descripcion">El modalidad es requerido.</small>
          </div>
        </div>
  
        <div class="p-formgrid grid">
          <div class="p-field col">
            <div class="p-field-checkbox flex items-center gap-2">
              <Checkbox
                id="Activo"
                name="Activo"
                :binary="true"
                v-model="modalidad.Activo"
              />
              <label for="Activo" class="m-0">Activo</label>
            </div>
          </div>
        </div>

        <template #footer>
          <Button
            label="Cancelar"
            icon="pi pi-times"
            class="p-button-text"
            @click="cancelarDialogo"
          />
          <Button
            label="Guardar"
            icon="pi pi-check"
            class="p-button-text"
            id="btnGuardar"
            @click="guardarModalidad"
          />
        </template>
      </Dialog>
      <ConfirmDialog></ConfirmDialog>
    </div>
</template>
  
<script>
  import SCatalogos from "../service/Tipos_modalidades";
  import { FilterMatchMode } from "primevue/api";
  import { ConfirmDialog } from 'primevue/confirmdialog';
  import {mapGetters} from 'vuex';
  
  export default {
      components: {
      ConfirmDialog
    },
    data() {
      return {
        Activo: false,
        lstModalidades: null,
        filters: {
          global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        },
        filter: null,
        loading: true,
        submitted: false,
        showAgregar: false,
        modoEdicion: "",
        modalidad: {},
        mensajes:"",
        usuario: {},
        lstEstatus: [],
      };
    },
    created() {
      this.getModalidades();
    },
    methods: {
      getModalidades() {
        var t = this;
        var CSrvr = new SCatalogos();
        t.loading = true;
  
        CSrvr.getModalidades(t)
          .then((res) => {
            t.lstModalidades = res;
            t.loading = false;
          })
          .catch(function (error) {
            console.error("Error:", error);
            t.loading = false;
          });
      },
      getFechaWCF(fecha, hora) {
        if (fecha) {
          var millis = fecha
            .replace("/Date(", "")
            .replace("/", "")
            .replace(")", "");
  
          millis = millis * 1;
  
          if (millis > 0) {
            var mfecha = new Date(millis);
  
            var res =
              mfecha.getDate() < 10 ? "0" + mfecha.getDate() : mfecha.getDate();
            res += "/";
            res +=
              mfecha.getMonth() + 1 < 10
                ? "0" + (mfecha.getMonth() + 1)
                : mfecha.getMonth() + 1;
            res += "/";
            res += mfecha.getFullYear();
  
            if (hora) {
              res += " ";
              res += mfecha.getHours();
              res += ":";
              res +=
                mfecha.getMinutes() < 10
                  ? "0" + mfecha.getMinutes()
                  : mfecha.getMinutes();
            }
  
            return res;
          } else {
            return "N/D";
          }
        }
      },
      collapseAll() {
        this.expandedRows = null;
      },
      forzarUpdate() {
        this.$forceUpdate();
      },
      agregarModalidad() {
        var t = this;
        var CSrvr = new SCatalogos();
        t.loading = true;
        CSrvr.getEstatus(t).then((res) => {
          t.lstEstatus = res;
          t.loading = false;
        });

        this.submitted = false;
        this.showAgregar = true;
        this.modoEdicion = "Agregar";
        this.mensajes = "";
        this.modalidad.Activo = false;
      },
      cancelarDialogo() {
        this.submitted = false;
        this.showAgregar = false;
        this.modoEdicion = "";
        this.modalidad = {};
        this.mensajes = "";
      },
      edit(obj) {
        var t = this;
        var CSrvr = new SCatalogos();
        t.loading = true;
        CSrvr.getEstatus(t).then((res) => {
          t.lstEstatus = res;
          t.loading = false;
        });
        this.modalidad = { ...obj };
        this.showAgregar = true;
        this.modoEdicion = "Editar";
        if(obj.Estatus == "ACTIVO"){
          this.modalidad.Activo = true;
        }
      },
      borrar(obj) {
        var t = this;      
        t.$confirm.require({
          message: '¿Quiere desactivar el modalidad?',
          header: 'Confirmación',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: 'Sí, eliminar',
          rejectLabel: 'Cancelar',
          acceptClass: 'p-button-danger',
          accept: () => {
            var val = obj;
            var ctlSvr = new SCatalogos();

            ctlSvr.getEstatus(t).then((res) => {
              t.lstEstatus = res;
              t.loading = false;

              obj.Activo = false;
              obj.Estatus = "INACTIVO";
              obj.Usuario_modificacion = t.getUsuarioLogueado.Usuario.Usuario;

              const estatusEncontrado = t.lstEstatus.find(e => e.Estatus === "INACTIVO");
              if (estatusEncontrado) {
                obj.Id_estatus = estatusEncontrado.Id_estatus;
              }
              
              ctlSvr.updateModalidad(t, val).then(() => {
                t.$toast.add({
                  severity: "success",
                  summary: "AVISO",
                  detail: "Insumo eliminado correctamente",
                  life: 3000,
                });
                t.getModalidades();
              });
            });
          },
          reject: () => {
            // Usuario canceló
          }
        });
      },
      guardarModalidad() {
        var t = this;
        this.submitted = true;
        const usuario = t.getUsuarioLogueado.Usuario.Usuario;

        if (!t.modalidad || !t.modalidad.Descripcion) {
          t.mensajes = "Algunos campos faltantes son obligatorios";
          return;
        }
  
        if (t.modalidad.Activo == false) {
          t.modalidad.Estatus = "INACTIVO";

          const estatusEncontrado = t.lstEstatus.find(e => e.Estatus === "INACTIVO");
          if (estatusEncontrado) {
            t.modalidad.Id_estatus = estatusEncontrado.Id_estatus;
          }

        } else {
          t.modalidad.Estatus = "ACTIVO";

          const estatusEncontrado = t.lstEstatus.find(e => e.Estatus === "ACTIVO");
          if (estatusEncontrado) {
            t.modalidad.Id_estatus = estatusEncontrado.Id_estatus;
          }
        }

        t.modalidad.Usuario_creacion = usuario;

        this.sendRequest(t, t.modalidad);
      },
      sendRequest(t, obj){
        var CSrvr = new SCatalogos();
          if (t.modoEdicion == "Agregar") {
            CSrvr.addModalidad(t, obj).then(() => {
              t.$toast.add({
                severity: "success",
                summary: "AVISO",
                detail: "Insumo agregado correctamente",
                life: 3000,
              });
              t.cancelarDialogo();
              t.getModalidades();
            });
          } else {
            obj.Usuario_modificacion = t.getUsuarioLogueado.Usuario.Usuario;

            if (obj.Activo == false) {
            obj.Estatus = "INACTIVO";

            const estatusEncontrado = t.lstEstatus.find(e => e.Estatus === "INACTIVO");
            if (estatusEncontrado) {
              obj.Id_estatus = estatusEncontrado.Id_estatus;
            }

            } else {
              obj.Estatus = "ACTIVO";

              const estatusEncontrado = t.lstEstatus.find(e => e.Estatus === "ACTIVO");
              if (estatusEncontrado) {
                obj.Id_estatus = estatusEncontrado.Id_estatus;
              }
            }
            
            CSrvr.updateModalidad(t, obj).then(() => {
              t.$toast.add({
                severity: "success",
                summary: "AVISO",
                detail: "Insumo editado correctamente",
                life: 3000,
              });
              t.cancelarDialogo();
              t.getModalidades();
            });
          }
      }
    },
    computed:{
      ...mapGetters(['getUrlServicios','getUsuarioLogueado']),  
    },       
  };
</script>
  
  <style scoped>
  .table-header {
    display: flex;
    justify-content: space-between;
    -webkit-box-pack: justify;
  }
  .title {
    font-weight: 700;
    letter-spacing: 0.3px;
    margin-right: 10px;
    text-transform: uppercase;
  }
  .data {
    letter-spacing: 0.3px;
    margin-right: 10px;
    letter-spacing: 0.5px;
  }
  .product-image {
    width: 100px;
  }
  </style>
  